@if (shouldShowPermissionRequest()) {
    <div class="notification-permission-overlay">
        <mat-card class="permission-card">
            <div class="permission-header">
                <h2>
                    @if (isSoftReminder()) {
                        Aktivér notifikationer for denne bruger
                    } @else {
                        Få besked om nye dokumenter
                    }
                </h2>
            </div>

            <div class="permission-content">
                @if (shouldOverwriteExistingSubscription()) {
                    <p>Der er allerede tilmeldt notifikationer for en anden bruger på denne enhed. Vil du overskrive og aktivere for denne bruger?</p>
                } @else if (isSoftReminder()) {
                    <p>Du har tilladt notifikationer på telefonen — aktivér dem for denne bruger, så du får besked om nye dokumenter.</p>
                } @else {
                    <p>Få besked på din telefon når der er nyheder fra din forsyning.</p>
                }
            </div>

            <div class="permission-actions">
                <button mat-raised-button color="primary" (click)="requestPermission()" [disabled]="isLoading()" class="allow-button">
                    <mat-icon class="button-icon" svgIcon="menu-beskeder"></mat-icon>
                    {{
                        isLoading()
                            ? "Aktiverer..."
                            : shouldOverwriteExistingSubscription()
                              ? "Tillad og overskriv"
                              : isSoftReminder()
                                ? "Aktivér notifikationer"
                                : "Tillad notifikationer"
                    }}
                </button>

                @if (shouldOverwriteExistingSubscription()) {
                    <button mat-button (click)="cancelOverwriteRequest()" [disabled]="isLoading()" class="block-button">
                        <mat-icon class="button-icon" svgIcon="close"></mat-icon>
                        Annuller
                    </button>

                    <button mat-button (click)="blockNotifications()" [disabled]="isLoading()" class="block-button">
                        <mat-icon class="button-icon" svgIcon="block"></mat-icon>
                        Fjern notifikationer
                    </button>
                } @else {
                    <button mat-button (click)="blockNotifications()" [disabled]="isLoading()" class="block-button">
                        <mat-icon class="button-icon" svgIcon="block"></mat-icon>
                        {{ isSoftReminder() ? "Ikke nu" : "Tillad ikke notifikationer" }}
                    </button>
                }
            </div>
        </mat-card>
    </div>
}
